import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // Log error only in development
    if (process.env.NODE_ENV === 'development') {
      console.error('ErrorBoundary caught an error:', error, errorInfo);
    }
    
    this.setState({
      error: error,
      errorInfo: errorInfo
    });
  }

  render() {
    if (this.state.hasError) {
      // Don't show error UI in production, just render children normally
      if (process.env.NODE_ENV === 'production') {
        return this.props.children;
      }

      // In development, you can choose to show error details or hide them
      if (this.props.showError === false) {
        return this.props.children;
      }

      // Default fallback UI for development
      return (
        <div style={{ 
          padding: '20px', 
          margin: '20px', 
          border: '1px solid #red', 
          borderRadius: '5px',
          backgroundColor: '#ffeaa7'
        }}>
          <h2>Something went wrong.</h2>
          {this.props.showDetails && (
            <details style={{ whiteSpace: 'pre-wrap' }}>
              <summary>Error details (development only)</summary>
              {this.state.error && this.state.error.toString()}
              <br />
              {this.state.errorInfo.componentStack}
            </details>
          )}
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
